var isScrollifyMove = false;
var isAnchorScroll = false;
$(document).ready(function () {

	$('.watch_the_video a,.video_org_btn').click(function(){
		let id = $(this).attr('data-id');
		vnsModal.youtubeOpen(id);
		return false;
	})
	
	//Anchor
	//-------------------------------------------
	$('.product_anchor_link[href^="#"]').click(function() {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position;

		if (target.length) {
			position = target.offset().top;
		} else {
			position = 0;
		}
		isAnchorScroll = true;

		autoScroll(position);

		return false;
	});

	let hash = location.hash;
	let hash_pos = 0;
	if(hash){
		if(hash.length > 2 && $(hash).length){
			hash_pos = $(hash).offset().top;

			setTimeout(function(){
				autoScroll(hash_pos,3000);
			},1000)
			
		}
	}
});

var autoScroll = function(position_px,speed = 750){
	$("html, body").animate({ scrollTop: position_px }, speed, "swing" ,function(){
		isAnchorScroll = false;
	});
}
